<template>
  <HomePage0 v-if="type==0"/>
  <HomePage1 v-else/>
</template>

<script>
import HomePage0 from "./HomePage0";
import HomePage1 from "./HomePage1";
import db from 'utils/localstorage'
export default {
  name: "HomePage",
  components: {
    HomePage0,HomePage1
  }, data() {
    return {
      type: 0
    }
  },

  beforeMount() {
    let user = db.get('USER',{})
    this.type = user.companyName?1:0
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue